import { Controller } from '@hotwired/stimulus';

import RailsApi from '../models/rails-api';

export default class extends Controller {
  static targets = ['content', 'container'];

  declare contentTarget: HTMLElement;

  declare containerTarget: HTMLElement;

  disconnect() {
    this.hideSpinner();
  }

  close() {
    this.containerTarget.classList.remove('is-open');
    this.contentTarget.innerHTML = '';
  }

  clickAway(e: Event) {
    if (
      !this.contentTarget.contains(e.target as HTMLInputElement) &&
      this.containerTarget.classList.contains('is-open')
    ) {
      this.close();
    }
  }

  async open(e: Event) {
    this.legacyShowSpinner();
    await this.fetchModalContent((e.target as HTMLElement).dataset.href!);
  }

  hideSpinner() {
    const spinner = document.querySelector('.LoadingSpinner-background');
    spinner?.remove();
  }

  legacyShowSpinner() {
    const template = document.getElementById('loadingSpinnerTemplate') as HTMLTemplateElement | null;
    if (template) document.body.appendChild(template.content.cloneNode(true));
  }

  async fetchModalContent(route: string) {
    await RailsApi.fetch(route)
      .then(response => {
        if (response.status === 200) {
          return Promise.resolve(response);
        }
        this.hideSpinner();
        return Promise.reject(new Error(response.statusText));
      })
      .then(response => response.text())
      .then(html => {
        const htmlFragment = document.createRange().createContextualFragment(html);
        this.contentTarget.replaceChildren(htmlFragment);
        this.containerTarget.classList.add('is-open');
        this.containerTarget.dispatchEvent(new CustomEvent('fetch-modal.contentLoaded', { bubbles: true }));
        this.hideSpinner();
      });
  }
}
